export default __webpack_public_path__ + "static/logo-47e7d30ba178007fbe08bdcf3c586462.png";